export default __webpack_public_path__ + "static/media/normal.104fa571.png";